module.exports = __webpack_public_path__ + "assets/media/feedback-ios.1c16dfa4.mp4";